// Helpers UI partagés pour le module SIGNA CARE.
import { API, getToken } from "@/lib/api";

export const STATE_META = {
  non_evalue: { label: "Non évalué", cls: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
  bon_etat: { label: "Bon état apparent", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  a_controler: { label: "À contrôler", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  intervention_a_prevoir: { label: "Intervention à prévoir", cls: "bg-orange-50 text-orange-700 border-orange-200", dot: "bg-orange-500" },
  hors_service: { label: "Hors service", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
  retire: { label: "Retiré du service", cls: "bg-slate-200 text-slate-700 border-slate-300", dot: "bg-slate-500" },
};

export const CATEGORY_ICON = {
  plots_solaires: "Sun",
  nez_marches: "Footprints",
  marqueurs_photo: "Sparkles",
  podotactiles: "Grip",
  reflecteurs: "Disc3",
  autre: "Package",
};

export const EVENT_ICON = {
  pose: "Wrench",
  controle: "ClipboardCheck",
  signalement: "TriangleAlert",
  entretien: "Brush",
  reparation: "Hammer",
  remplacement: "RefreshCw",
  retrait: "PackageX",
};

export const DUE_META = {
  overdue: { label: "En retard", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  due_soon: { label: "Échéance proche", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export function careFileUrl(fileId) {
  return `${API}/care/files/${fileId}/download?auth=${getToken()}`;
}
